<template>
  <div class="bar-loader">
    <div class="bar-item"></div>
    <div class="bar-item"></div>
    <div class="bar-item"></div>
    <div class="bar-item"></div>
    <div class="bar-item"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>

<style scoped>
.bar-loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bar-item {
  display: inline-block;
  width: 4px;
  height: 20px;
  margin: 0 3px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  animation: scale-up4 1s linear infinite;
}

.bar-item:nth-child(1) {
  animation-delay: 0s;
}

.bar-item:nth-child(2) {
  height: 25px;
  animation-delay: 0.15s;
}

.bar-item:nth-child(3) {
  height: 32px;
  animation-delay: 0.3s;
}

.bar-item:nth-child(4) {
  height: 25px;
  animation-delay: 0.45s;
}

.bar-item:nth-child(5) {
  animation-delay: 0.6s;
}

@keyframes scale-up4 {
  20% {
    background-color: #ffff;
    transform: scaleY(1.2);
  }

  40% {
    transform: scaleY(1);
  }
}
</style>
